module.exports = __webpack_public_path__ + "static/media/ic-mic-disabled.6d97c20f.png";